import React from 'react';
import { ArrowRight, Download, Smartphone, TrendingUp, AlertCircle } from 'lucide-react';
import { PaymentIcons } from './PaymentIcons';
export function FinalCTASection() {
  return <section id="cta-section" className="w-full bg-gradient-to-b from-gray-800 to-gray-900 py-16 px-4" data-id="element-15">
      <div className="max-w-xl mx-auto text-center" data-id="element-16">
        <h2 className="text-3xl font-bold text-white mb-4" data-id="element-17">
          Subconscious Activation
        </h2>
        <div className="bg-gray-700 rounded-full py-2 px-6 inline-block mb-4" data-id="element-18">
          <p className="text-gray-100 font-semibold" data-id="element-19">
            Only 85 copies available
          </p>
        </div>
        <p className="text-lg text-gray-300 mb-10" data-id="element-20">
          Right now… you can download The Charlie Kirk Method. And begin
          retraining how you influence the world.
        </p>
        <div className="bg-gray-800 rounded-lg shadow-xl overflow-hidden mb-8 border border-gray-700" data-id="element-21">
          {/* Header dark section */}
          <div className="bg-gray-900 text-white py-6 px-4 border-b border-amber-700" data-id="element-22">
            <h3 className="text-2xl font-bold mb-2 text-amber-500" data-id="element-23">
              THE CHARLIE KIRK METHOD
            </h3>
            <p className="text-amber-300" data-id="element-24">Complete leadership system</p>
          </div>
          {/* Product image */}
          <div className="p-4 bg-gray-800" data-id="element-25">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4S5MqG5bKeKCGdqJ7Q3XwL/ChatGPT_Image_30_sept_2025%2C_16_25_26.webp" alt="The Charlie Kirk Method Book" className="w-full h-auto rounded-lg" data-id="element-26" />
          </div>
          {/* CTA elements */}
          <div className="px-8 py-4" data-id="element-27">
            {/* Price section */}
            <div className="flex justify-center items-center mb-6" data-id="element-28">
              <span className="text-gray-400 line-through text-xl" data-id="element-29">
                $39 USD
              </span>
              <span className="text-4xl font-bold text-amber-500 ml-4" data-id="element-30">
                $19 USD
              </span>
            </div>
            {/* Limited time offer notice */}
            <div className="bg-gray-900 py-4 px-6 border-l-4 border-amber-500 flex items-start mb-6 rounded" data-id="element-31">
              <AlertCircle size={20} className="text-amber-400 mr-2 flex-shrink-0 mt-1" data-id="element-32" />
              <p className="text-gray-300 text-left text-sm" data-id="element-33">
                <span className="font-semibold text-amber-300" data-id="element-34">
                  Limited time offer!
                </span>{' '}
                After 200 copies sold, the price will return to $39 USD
              </p>
            </div>
            {/* Benefits */}
            <div className="mb-6" data-id="element-35">
              <div className="flex items-center py-3" data-id="element-36">
                <Download size={20} className="text-amber-500 mr-3" data-id="element-37" />
                <p className="text-gray-200" data-id="element-38">Immediate download</p>
              </div>
              <div className="flex items-center py-3" data-id="element-39">
                <Smartphone size={20} className="text-amber-500 mr-3" data-id="element-40" />
                <p className="text-gray-200" data-id="element-41">Access from any device</p>
              </div>
              <div className="flex items-center py-3" data-id="element-42">
                <TrendingUp size={20} className="text-amber-500 mr-3" data-id="element-43" />
                <p className="text-gray-200" data-id="element-44">Start leading immediately</p>
              </div>
            </div>
            {/* FREE BONUSES Banner */}
            <div className="bg-gray-900 py-3 px-4 mb-6 border-l-4 border-amber-600 rounded" data-id="element-45">
              <p className="text-amber-400 font-bold" data-id="element-46">
                Includes 2 FREE LEADERSHIP BONUSES
              </p>
            </div>
            {/* CTA Button */}
            <a href="https://ebooksociety.co/cart/51475293536537:1" className="w-full bg-amber-600 hover:bg-amber-700 text-white font-bold py-4 px-6 rounded-lg text-xl transition inline-block text-center shadow-lg mb-4" data-id="element-47">
              Download Your Copy Now
            </a>
            {/* Payment Icons */}
            <PaymentIcons data-id="element-48" />
            {/* Final note */}
            <p className="text-gray-400 text-sm text-center mt-4 mb-2" data-id="element-49">
              One-time payment. No subscriptions or hidden charges.
            </p>
          </div>
        </div>
        <p className="text-lg text-amber-300 font-medium" data-id="element-50">
          In the midst of chaos… there are only two kinds of people: Those who
          wait. And those who lead.
        </p>
        <p className="text-lg text-white font-bold mt-4" data-id="element-51">
          You decide which voice gets heard.
        </p>
      </div>
    </section>;
}